// extracted by mini-css-extract-plugin
export default {"icon":"status-icon_icon__KZwq1"};